import React from 'react';

import addProjectFormModel from "../AddNewProject/FormModel/AddProjectFormModel";

import { getFormattedDate } from "../../../utils/getFormattedDateTime";

import { StyledGridContainer, StyledPaper } from "../styles"
import { Typography, Grid, ListItemText, ListItem, List } from '@mui/material';


const { formField } = addProjectFormModel;

function ProjectPhaseDetails(props) {
  const {
    formValues }
    = props;
  const isProjectStudy = typeof formValues?.isProjectStudy === 'boolean'
    ? formValues.isProjectStudy
    : String(formValues?.isProjectStudy || '').toLowerCase() === 'yes';

  return (
    <Grid item xs={12} md={12}>
      <StyledPaper elevation={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <List role="presentation">
              <ListItem role="presentation">
                <ListItemText
                  aria-label="Description"
                  primary={<b>Description</b>}
                  secondary={formValues.description || "None"}
                />
              </ListItem>
            </List>
          </Grid>

          {formValues.projectDetails?.length > 0 && (
            <table style={{ width: 'calc(100% - 32px)', borderCollapse: 'collapse', margin: '8px 32px' }} aria-label="Project Phase Details">
              <thead>
                <tr style={{ textAlign: 'left' }}>
                  <th style={{ padding: '8px' }}>Phase #</th>
                  <th style={{ padding: '8px' }}>CSJ/Plan ID #</th>
                  <th style={{ padding: '8px' }}>{isProjectStudy ? 'Study Start Date' : 'Let Date'}</th>
                  <th style={{ padding: '8px' }}>Completion Date</th>
                  {isProjectStudy && (
                    <th style={{ padding: '8px' }}>Study Cost ($)</th>
                  )}
                  <th style={{ padding: '8px' }}>Cost Estimate ($)</th>
                </tr>
              </thead>
              <tbody>
                {formValues.projectDetails.map((row, index) => (
                  <tr key={index}>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">
                        {row.phase}
                      </Typography>
                    </td>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">
                        {row.csjNumber || "None"}
                      </Typography>
                    </td>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">
                        {row.letDate ? getFormattedDate(new Date(row.letDate)) : "None"}
                      </Typography>
                    </td>
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">
                        {row.completionDate ? getFormattedDate(new Date(row.completionDate)) : "None"}
                      </Typography>
                    </td>
                    {isProjectStudy && (
                      <td style={{ padding: '8px' }}>
                        <Typography variant="body2">
                          {row.studyCost || "None"}
                        </Typography>
                      </td>
                    )}
                    <td style={{ padding: '8px' }}>
                      <Typography variant="body2">
                        {row.costEstimate || "None"}
                      </Typography>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Grid>
      </StyledPaper>
    </Grid>
  );
}

export default ProjectPhaseDetails;